import React from 'react';
import { useSelector }  from 'react-redux';
import { isEmpty, isLoaded } from 'react-redux-firebase';
import { Route, Redirect } from 'react-router-dom';
import DefaultLayout from '../containers/DefaultLayout/DefaultLayout';
import Trade from '../pages/Trade';

function AuthRoute({children, ...rest}) {
    const auth = useSelector(state => state.firebase.auth);
    const props = {...rest};
    return (
        <Route 
            {...rest} 
            render={({location}) => 
                isLoaded(auth) && !isEmpty(auth)
                ? ( props.path == "/trade"
                    ? <Trade />
                    : <DefaultLayout {...rest}/>
                )
                : (
                    <Redirect to = {{pathname:"/login", state:{from:location}}} />
                )
            }/>
    );
}

export default AuthRoute;